// Self-contained "Top posts" widget for the Content view. Composes the
// entity-level TopPostsList with a section header. The list shape is
// shared with the Overview widget (entities/message exposes one structural
// `TopPostListItem` interface).

import type { ContentTopPost } from "@community-analytics/shared";

import { TopPostsList } from "@entities/message";
import { cn } from "@shared/lib";

import { TOP_POSTS_STRINGS } from "../lib/strings";

export interface TopPostsBoardProps {
  posts: ReadonlyArray<ContentTopPost>;
  className?: string;
}

export function TopPostsBoard({ posts, className }: TopPostsBoardProps) {
  return (
    <section
      aria-labelledby="top-posts-title"
      className={cn("flex flex-col gap-2", className)}
    >
      <header>
        <h2 id="top-posts-title" className="text-sm font-semibold">
          {TOP_POSTS_STRINGS.title}
        </h2>
        <p className="text-xs text-muted-foreground">
          {TOP_POSTS_STRINGS.subtitle}
        </p>
      </header>
      <TopPostsList
        posts={posts}
        emptyLabel={TOP_POSTS_STRINGS.empty}
        reactionsLabel={TOP_POSTS_STRINGS.reactions}
        repliesLabel={TOP_POSTS_STRINGS.replies}
      />
    </section>
  );
}
